import React from 'react';
import toUpper from 'lodash/toUpper'
import FormInput from 'components/forms/bases/FormInput';
import CustomTabs from 'components/Tabs/CustomTabs'
import FormLabel from 'components/labels/FormLabel'
import withIntl from 'store/intl/withIntl'

const langText = {
  en: 'English',
  th: 'ไทย',
}

const langLabel = {
  en: 'Language',
  th: 'ภาษา',
}

const FormLanguage = withIntl()(
  ({
    label,
    value,
    onChange,
    currentLang,
    availableLanguages,
    switchLanguage,
    rows = 3,
    rowsMax = 5,
  }) => (
    <div>
      <FormLabel>{label || langLabel[currentLang]}</FormLabel>
      <CustomTabs
        defaultTabValue={currentLang}
        onTouchTab={switchLanguage}
      >
        {availableLanguages.map((lang) => (
          <FormInput
            key={lang}
            style={{ marginLeft: 10, marginTop: 0 }}
            tabValue={lang}
            tabLabel={toUpper(lang)}
            hintText={langText[lang]}
            rows={rows}
            rowsMax={rowsMax}
            value={value[lang]}
            onChange={(val) => onChange({ ...value, [lang]: val })}
            multiLine
          />
        ))
        }
      </CustomTabs>
    </div>
  ),
);

export default FormLanguage;



// WEBPACK FOOTER //
// ./src/components/forms/FormTextAreaWithLanguage.js